import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Config } from '../config/config';

export interface UserApiKeySummary {
  id: string;
  name: string;
  keyPrefix: string;
  createdAt: number;
  lastUsedAt: number | null;
  enabled: boolean;
  description: string;
}

export interface CreateUserApiKeyResponse {
  id: string;
  name: string;
  apiKey: string; // Full key, only returned once on creation
  keyPrefix: string;
  createdAt: number;
}

@Injectable({
  providedIn: 'root',
})
export class UserApiKeysService {
  private apiUrl = Config.backend_url + '/user-api-keys';

  constructor(private http: HttpClient) {}

  createApiKey(name?: string, description?: string): Observable<CreateUserApiKeyResponse> {
    return this.http.post<CreateUserApiKeyResponse>(this.apiUrl, { name, description });
  }

  listApiKeys(): Observable<UserApiKeySummary[]> {
    return this.http.get<UserApiKeySummary[]>(this.apiUrl);
  }

  getApiKey(keyId: string): Observable<UserApiKeySummary> {
    return this.http.get<UserApiKeySummary>(`${this.apiUrl}/${keyId}`);
  }

  updateApiKey(
    keyId: string,
    updates: { name?: string; description?: string; enabled?: boolean }
  ): Observable<UserApiKeySummary> {
    return this.http.patch<UserApiKeySummary>(`${this.apiUrl}/${keyId}`, updates);
  }

  deleteApiKey(keyId: string): Observable<{ success: boolean; message: string }> {
    return this.http.delete<{ success: boolean; message: string }>(`${this.apiUrl}/${keyId}`);
  }
}

